module.exports = {"632301100":"隆务镇","632301101":"保安镇","632301102":"多哇镇","632301200":"兰采乡","632301201":"双朋西乡","632301202":"扎毛乡","632301203":"黄乃亥乡","632301204":"曲库乎乡","632301205":"年都乎乡","632301206":"瓜什则乡","632301207":"加吾乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/632301.json
// module id = 3136
// module chunks = 0